import {Check} from '@sparkware/app-utils';
import {HOME_PAGE} from '../../../themes/css-global-classes';

export class UriPath {
  constructor(path: string) {
    this._path = (path || '/').trim();
  }

  private readonly _path: string;
  toString(): string {
    if(this._path[0] !== '/') {
      return '/' + this._path;
    }

    return this._path;
  }

  getBase(): UriPath {
    let parts = this.toString().split('/');
    return new UriPath(parts[0] +'/' + parts[1]);
  }

  toArray(): string[] {
    let parts = this.toString().split('/').filter(part => part);
    return ['/', ...parts];
  }

  equals(theOther: UriPath): boolean {
    if(Check.isNullOrUndefined(theOther)) {
      return false;
    }
    return this._appendSlashToTheEnd(this.toString()).toLowerCase() === this._appendSlashToTheEnd(theOther.toString()).toLowerCase();
  }

  get isEmpty(): boolean {
    return this._path === '/';
  }

  toCssClassName(): string {

    let urlWithoutTrailingSlashes = this.toString();

    if(urlWithoutTrailingSlashes[0] === '/') {
      urlWithoutTrailingSlashes = urlWithoutTrailingSlashes.substring(1)
    }

    if(urlWithoutTrailingSlashes[urlWithoutTrailingSlashes.length - 1] === '/') {
      urlWithoutTrailingSlashes = urlWithoutTrailingSlashes.substring(0, urlWithoutTrailingSlashes.length - 1);
    }


    if(urlWithoutTrailingSlashes) {
      return urlWithoutTrailingSlashes.toLowerCase().replace('/', '-') + '-page';
    } else {
      return HOME_PAGE;
    }
  }

  static areEquals(p1: UriPath, p2: UriPath): boolean {
    if(Check.isNullOrUndefined(p1)) {
      if(Check.isNullOrUndefined(p2)) {
        return true;
      } else {
        return false;
      }
    } else {
      return p1.equals(p2);
    }
  }

  private _appendSlashToTheEnd(url: string): string {
    if(url[url.length - 1] !== '/') {
      url = url + '/';
    }

    return url;
  }

  append(other: UriPath | string): UriPath {
    if(!(other instanceof UriPath)) {
      other = new UriPath(other);
    }



    return new UriPath((this.toString() + other.toString()).replace('//', '/'));
  }
}
